import React from 'react';
import { Button, HoverStyles, Text, TextTypography } from 'wix-ui-tpa/cssVars';
import { TPA_EXPERIMENTS } from '@wix/pricing-plans-common/experiments';
import { VIEWER_HOOKS } from '@wix/pricing-plans-common/hooks';
import { useExperiments, useTranslation } from '@wix/yoshi-flow-editor';
import { st, classes } from './EmptyState.st.css';

export type EmptyStateProps = { subtitle?: string } & EmptyStateHandler;

type EmptyStateHandler = { isInWidget: true } | { isInWidget: false; onClick: () => void };

export const EmptyState: React.FC<EmptyStateProps> = (props) => {
  const { t } = useTranslation();
  const { experiments } = useExperiments();
  const isUnderlineEnabled = experiments.enabled(TPA_EXPERIMENTS.HOVER_STYLE_UNDERLINE);

  return (
    <div className={st(classes.wrapper, { widget: props.isInWidget })} data-hook={VIEWER_HOOKS.EMPTY_STATE}>
      <Text className={classes.title} typography={TextTypography.smallTitle}>
        {t('pp.empty-state.title')}
      </Text>
      <Text
        className={classes.subtitle}
        typography={TextTypography.runningText}
        data-hook={VIEWER_HOOKS.EMPTY_STATE_SUBTITLE}
      >
        {props.subtitle ?? t('pp.empty-state.subtitle')}
      </Text>
      <div>
        {!props.isInWidget && (
          <Button
            hoverStyle={isUnderlineEnabled ? HoverStyles.underline : undefined}
            data-hook={VIEWER_HOOKS.EMPTY_STATE_BUTTON}
            onClick={props.onClick}
            upgrade
            className={classes.button}
          >
            {t('pp.empty-state.button')}
          </Button>
        )}
      </div>
    </div>
  );
};
